module.exports = __webpack_public_path__ + "img/57.f4b56fa7.svg";